export const content = {
  title: 'Compare Group plans​',
  titleMobile: 'Group your plans together.',
  description:
    'To start a Group, you need a minimum of two people or devices. Use our nifty calculator to find the best Group plan for you.',
  everyoneUnlimitedTitle: 'Everyone Unlimited',
  everyoneUnlimitedSubtitle: 'Monthly cost',
  everyoneUnlimitedDescription: (ownerPrice, memberPrice) =>
    `£${ownerPrice} for the group owner, plus £${memberPrice} per member`,
  everyoneUnlimitedTotalLabel: 'Monthly total',
  mixAndMatchTitle: 'Mix and Match',
  mixAndMatchSubtitle: 'Monthly cost',
  mixAndMatchDescription: '10% Discount per group member',
  mixAndMatchTotalLabel: 'Monthly total, including 10% discount',
  groupOwnerLabel: 'Group owner',
  groupMemberLabel: '+ 1 member',
  bottomNoteLabel: 'Please note:',
  bottomNoteText: 'The prices shown are for illustration purpose only.',
}
